import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdQueuesManageRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-queues-manage',
	path: '/projects/:projectKey/queues/manage',
};
